import store from "../store";
const dics = [
  {
    title: "filter",
    az: "İstədiyini tap",
    en: "Find what you need",
    ru: "Найдите что желаете",
  },
  {
    title: "ingrad",
    az: "Tərkibini göstər",
    en: "Show ingradients",
    ru: "Инградиенты",
  },
  { title: "showall", az: "Tam siyahı", en: "Show all", ru: "Показать все" },
  { title: "search", az: "Axtar", en: "Search", ru: "Поиск" },
  { title: "found", az: "Tapılıb", en: "Found", ru: "Найдено" },
  { title: "searchresult", az: "Axtarışın nəticəsi", en: "Search result", ru: "Результат поиска" },
  { title: "or", az: "Və ya", en: "Or", ru: "Или" },
  { title: "selectcat", az: "Menyudan seçin", en: "Select from the menu below", ru: "Выбкрите из меню ниже" },
  { title: "tobasket", az: "Səbətə əlavə et", en: "Add to cart", ru: "Добавить в карзину" },
  { title: "gotobasket", az: "Səbətə keçmək", en: "To cart", ru: "Перейти в карзину" },
  { title: "name", az: "Adı", en: "Name", ru: "Название" },
  { title: "price", az: "Qiymət", en: "Price", ru: "Цена" },
  { title: "total", az: "Yekun", en: "Total", ru: "Итого" },
  { title: "count", az: "Say", en: "Count", ru: "Кол-во" },
  { title: "amount", az: "Məbləğ", en: "Sum", ru: "Сумма" },
  { title: "continueshop", az: "Menyuya geri qayıt", en: "Back to menu", ru: "Вернуться к меню" },
  { title: "shopcart", az: "Səbət", en: "Shopping Cart", ru: "Корзина" },
  { title: "finish", az: "Sifarişi yekunlaşdırmaq", en: "Complete Purchase", ru: "Завершить покупку" },
  { title: "customername", az: "Müştərinin adı", en: "Cusotmer name", ru: "ФИО" },
  { title: "phone", az: "Telefon", en: "Phone", ru: "Телефон" },
  { title: "email", az: "Email", en: "Email", ru: "Email" },
  { title: "payonline", az: "Online", en: "Online", ru: "Online" },
  { title: "paycash", az: "Nəğd ödəniş", en: "By cash", ru: "Наличными" },
  { title: "paybycard", az: "POS terminal", en: "By credit card (POS terminal)", ru: "По карте через терминал" },
  { title: "personalinfo", az: "Şəxsi məlumat", en: "Personal information", ru: "Личная информация" },
  { title: "paytype", az: "Ödəniş növü", en: "Payment method", ru: "Способ оплаты" },
  { title: "change", az: "Qalıq tələb olunan məbləğ (₼ 1-1000)", en: "Change for (₼ 1-1000)", ru: "Сдачи от (₼ 1-1000)" },
  { title: "deliverytype", az: "Çatdırılıma növü", en: "Delivery method", ru: "Способ доставки" },
  { title: "dlvrcourier", az: "Kuryer", en: "Courier", ru: "Курьер" },
  { title: "dlvrpickup", az: "Şəxsən daşınma", en: "Pick up yourself", ru: "Самовывоз" },
  { title: "dlvrimhere", az: "Restorandayam", en: "I'm here", ru: "Я в ресторане" },
  { title: "deliverytime", az: "Çatdırılıma vaxtı", en: "Delivery time", ru: "Время доставки" },
  { title: "now", az: "İndi", en: "ASAP", ru: "Сейчас" },
  { title: "later", az: "Daha sonra", en: "Later", ru: "Позже" },
  { title: "street", az: "Küçə", en: "Street", ru: "Улица" },
  { title: "entrance", az: "Giriş/blok", en: "Entrance", ru: "Вход/блок" },
  { title: "entrancecode", az: "Domofonun kodu", en: "Entrance code", ru: "Код домофона" },
  { title: "house", az: "Ev", en: "House", ru: "Дом" },
  { title: "floor", az: "Mərtəbə", en: "Floor", ru: "Этаж" },
  { title: "flatoffice", az: "Mənzil/Ofis", en: "Flat/Office", ru: "Квартира/Офис" },
  { title: "addressnote", az: "Ünvan qeyd", en: "Note to address", ru: "Примечание к адресу" },
  { title: "tablenumber", az: "Masa nömrə", en: "Table number", ru: "Номер стола" },
  { title: "totalorderprice", az: "Endirim və çatdırılma nəzərə alınmaqla qiymət", en: "Price including discount and delivery", ru: "Цена с учетом скидки и доставки" },
  { title: "backtocart", az: "Səbətə qayıtmaq", en: "Back to cart", ru: "Вернуться в карзину" },
  { title: "finishorder", az: "Sifarişi yekunlaşdırmaq", en: "Place your order", ru: "Оформить заказ" },
  { title: "ordering", az: "Sifarişin yekunlaşdırılması", en: "Ordering", ru: "Оформление заказа" },
  { title: "fillrequireds", az: "Mütləq sahələri doldurun", en: "Fill required fields", ru: "Заполните обязательные поля" },
  { title: "select", az: "Seçin", en: "Select", ru: "Выберите" },
  { title: "ordernumber", az: "Sifarişin nömrəsi", en: "Order number", ru: "Номер заказа" },
  { title: "ordersent", az: "Sifariş göndərildi", en: "Order sent", ru: "Заказ отправлен" },
  { title: "close", az: "Bağla", en: "Close", ru: "Закрыть" },
  { title: "cartempty", az: "Səbətiniz boşdur", en: "Your cart is empty", ru: "Ваша корзина пуста" },
  { title: "example", az: "Nümunə", en: "Example", ru: "Пример" },
  { title: "showonmap", az: "Xəritədə göstər", en: "Show on map", ru: "Показать на карте" },
  { title: "selectedloc", az: "Seçilmiş yer", en: "Selected location", ru: "Выбранное место" },
  { title: "wtime", az: "İş vaxtı", en: "Working hours", ru: "Рабочее время" },
  { title: "available", az: "Mövcuddur", en: "Available", ru: "Доступно" },
  { title: "pax", az: "Nəfər", en: "Pax", ru: "Кол-во персон" },
  { title: "ordernow", az: "Sifariş", en: "Order", ru: "Заказ" },
  { title: "menu", az: "Menyu", en: "Menu", ru: "Меню" },
  { title: "reqtablepax", az: "Masa nömrəsi və Nəfər sütunları mütləqdir", en: "Table number and Pax fields are required", ru: "Поля Номер стола и Кол-во персон обязательны" },
];
export default {
  localeText(text) {
    let item = dics.filter((c) => c.title === text);
    if (item.length === 0) return "Label not found";
    switch (store.state.lang) {
      case "AZ":
        return item[0].az;
      case "EN":
        return item[0].en;
      case "RU":
        return item[0].ru;
    }
  },
};
